import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Layout from "../components/layout";
import RouterUsuarios from "./usuarios/router";
import RouterAdministracion from "./administracion/router";
import RouterDashboard from "./dashboard/router";
import RouterAsignacion from "./asignacion/router";
import RouterClientes from "./clientes/router";
import RouterAlmacen from "./almacen/router";
import RouterSeguimiento from "./seguimiento/router";
import RouterReportes from "./reportes/router";
import RouterIncidente from "./incidente/router";
import RouterViaje from "./viaje/router";

const RouterPage = () => {
  const { path } = useRouteMatch();
  // console.log('RouterPage ');
  // console.log(path);
  return (
    <Switch>
      <Layout>
        <Route path={`${path}dashboard`}>
          <RouterDashboard />
        </Route>
        <Route path={`${path}clientes`}>
          <RouterClientes />
        </Route>
        <Route path={`${path}almacen`}>
          <RouterAlmacen />
        </Route>
        <Route path={`${path}administracion`}>
          <RouterAdministracion />
        </Route>
        <Route path={`${path}asignacion`}>
          <RouterAsignacion />
        </Route>
        <Route path={`${path}incidente`}>
          <RouterIncidente />
        </Route>
        <Route path={`${path}seguimiento`}>
          <RouterSeguimiento />
        </Route>
        <Route path={`${path}usuarios`}>
          <RouterUsuarios />
        </Route>
        <Route path={`${path}reportes`}>
          <RouterReportes />
        </Route>
        <Route path={`${path}viaje`}>
          <RouterViaje />
        </Route>
        {/* <Route exact path={`${path}`}>
          <RouterDashboard />
        </Route> */}
      </Layout>
    </Switch>
  );
};

export default RouterPage;
